import React, { FunctionComponent, useRef, useEffect, useCallback } from "react";
import { Text, StyleProps } from "@chakra-ui/react";
import { select, interpolateRound, easeCubicIn, interpolate } from "d3";


interface IProps extends StyleProps{
  value?: number;
  decimals?: number;
  round?: boolean;
  signed?: boolean;
  title: string;
}


const TweenValue: FunctionComponent<IProps> = ({
  value,
  decimals,
  round = false,
  signed = false,
  ...rest
}) => {
  const valueRef = useRef<HTMLParagraphElement>(null);
  const signedValue = useCallback((val: number): string => `${signed && val > 0 ? "+" : ""}${decimals !== undefined ? val.toFixed(decimals) : val}`, [signed, decimals]);

  useEffect(() => {
    const sel = select(valueRef.current);

    sel
      .datum<number>(sel.datum() as number || 0)
      .transition()
        .duration(1500)
        .ease(easeCubicIn)
        .textTween(d => {
          if (typeof(value) !== "number") return t => "...";

          const i = (round ? interpolateRound : interpolate)(d, value);

          return t => sel.datum(i(t)) && signedValue(sel.datum() as number);
        })
        ;
  }, [valueRef, value, round, signedValue]);

  return <>
    <Text
      ref={valueRef}
      {...rest}
    />
  </>
}

export default TweenValue;
